import { validateConcede } from "@cloudnest/stone-flicking-core-engine/validators";
import type { SurrenderAction } from "../types/actions";
import type { ValidationResult } from "../types/common";
import type { StoneFlickingState } from "../types/game-state";
import { toParticipantId } from "../utils/state-mapper";

export function validateSurrender(
  state: StoneFlickingState,
  action: SurrenderAction,
): ValidationResult {
  return validateConcede(state.coreState, {
    type: "CONCEDE",
    participantId: toParticipantId(action.playerId),
  });
}
